import {ToastSuccess} from "utils/toast/Toast";

export const login = (token:string) => {
  logout();
  localStorage.setItem("token",token);
  window.location.href=window.location.origin;
  ToastSuccess("با موفقیت وارد شدید");
}

export const logout = () => {
  localStorage.removeItem("token");
}